import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';

import SampleColorPopUp from '@components/colors/SampleColorPopUp';
import CustomDropdown from '@components/CustomDropdown';
import { toastError, toastSuccess } from '@components/Toast';

import EODate from '@features/collection/components/EODate';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { clearSampleRequest, fetchSampleProductList } from '@store/actions/SampleAction';

import { findAllUsersByUserTypes } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { _getKey, checkUserType, getTodaysDate, packTag, setTag } from '@utils/Util';

const SampleAdd = ({ requestType, source, selectedDesignIds, onClose }) => {
	const [selectedDesigns, setSelectedDesigns] = useState([]);
	const [designId, setDesignId] = useState(null);
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [countryList, setCountryList] = useState([]);
	const [allCountryList, setAllCountryList] = useState([]);
	const [assigneeList, setAssigneeList] = useState([]);
	const [selectedAssignee, setSelectedAssignee] = useState({});
	const [eoDate, setEoDate] = useState(null);
	const sampleStore = useSelector((store) => store.sampleStore);
	const isLoading = useSelector((store) => store.loaderStore);
	const [errors, setErrors] = useState([]);
	const [isEoDateError, setIsEoDateError] = useState(false);
	const dispatch = useDispatch();
	const { id } = useParams();
	const navigate = useNavigate();
	const [selectedColors, setSelectedColors] = useState([]);
	const [isColorAddedOnce, setIsColorAddedOnce] = useState(false);
	const [assigneeError, setAssigneeError] = useState(false);

	useEffect(() => {
		setSelectedDesigns(sampleStore.selectedProducts.flat());
	}, [sampleStore]);
	const addNewRowInColorPopup = (item) => {
		let colors = item.colorResponseList[item.colorResponseList.length - 1];
		if (colors.code !== '' || colors.size !== null || colors.quantity !== null) {
			item.colorResponseList.push({
				key: _getKey(),
				code: '',
				hexCode: null,
				pantoneColorId: null,
				size: null,
				quantity: null
			});
		}
	};

	const fetchCountryList = () => {
		ApiClient.GET('getCountryListByUnits', 'SAMPLE_HOUSE')
			.then(({ data }) => {
				let lists = [];
				data.map((item) =>
					lists.push({ id: item.id, value: item.name, country: item.countryResponse })
				);
				setAllCountryList(lists);
			})
			.catch(() => {
				toastError('Unable to fetch Country list!');
			});
	};

	useEffect(() => {
		fetchCountryList();
		dispatch(openLoader());
		dispatch(fetchSampleProductList(selectedDesignIds)).finally(() => {
			dispatch(closeLoader());
		});
		(async () => {
			try {
				dispatch(openLoader());
				let params = '';

				if (checkUserType('FASHION_DESIGNER')) {
					if (requestType === 'COSTING') {
						params = '?userTypes=COSTING_MANAGER';
					} else {
						params = '?userTypes=PRODUCT_DEVELOPMENT';
					}
				} else {
					params =
						requestType === 'COSTING'
							? '?userTypes=COSTING_MANAGER'
							: '?userTypes=PROJECT_MANAGER&userTypes=PRODUCT_DEVELOPMENT&userTypes=MERCHANDISER';
				}

				const data = await findAllUsersByUserTypes(params);
				let userList = [];
				for (let item in data) {
					let users = data[item]?.map((item) => ({
						value: item.id,
						label: item.name,
						country: item.country
					}));
					userList = [...userList, ...users];
				}
				setAssigneeList(userList);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, []);

	const onDesignClick = (id) => {
		setDesignId(id);
	};

	const updateColors = (color, name, value) => {
		if (name === 'code' && !value) {
			color[name] = value;
			color['hexCode'] = null;
			color['pantoneColorId'] = null;
		} else {
			color[name] = value;
		}
	};

	const onChangeColorItem = (e, colorItem) => {
		const { name, value } = e.target;

		const updatedDesigns = selectedDesigns.map((design) => {
			if (design.isSet) {
				design.setItemsList = design.setItemsList.map((memberOfSet) => {
					memberOfSet.colorResponseList = memberOfSet.colorResponseList.map((color) => {
						if (color.key === parseInt(colorItem.key)) {
							updateColors(color, name, value);
						}
						return color;
					});
					addNewRowInColorPopup(memberOfSet);
					return memberOfSet;
				});
			} else {
				if (design.id === designId) {
					design.colorResponseList = design.colorResponseList.map((color) => {
						if (color.key === parseInt(colorItem.key)) {
							updateColors(color, name, value);
						}
						return color;
					});
					addNewRowInColorPopup(design);
				}
			}
			return design;
		});
		setSelectedDesigns([...updatedDesigns]);
	};

	// add New color from color popup
	const onClickAddNew = (color, key) => {
		let updatedDesigns = selectedDesigns;
		updatedDesigns.map((item) => {
			if (item?.isSet) {
				item.setItemsList.map((membersOfSet) => {
					if (membersOfSet.id === designId) {
						membersOfSet.colorResponseList.map((existingColor) => {
							if (existingColor.key === parseInt(key)) {
								existingColor['code'] = color.code;
								existingColor['hexCode'] = color.hexCode;
								existingColor['pantoneColorId'] = color.pantoneColorId;
								existingColor['colorType'] = 'SOLID';
							}
							return existingColor;
						});
						setSelectedColors(membersOfSet.colorResponseList);
					}
				});
			}
			if (item.id === designId) {
				item.colorResponseList.map((existingColor) => {
					if (existingColor.key === parseInt(key)) {
						existingColor['code'] = color.code;
						existingColor['hexCode'] = color.hexCode;
						existingColor['pantoneColorId'] = color.pantoneColorId;
						existingColor['colorType'] = 'SOLID';
					}
					return existingColor;
				});
				setSelectedColors(item.colorResponseList);
			}
		});
		if (selectedColors.length > 0) {
			setIsColorAddedOnce(true);
		}
		setSelectedDesigns([...updatedDesigns]);
	};

	const onChangeDate = (value, id) => {
		let updatedDesigns = selectedDesigns;
		updatedDesigns.forEach((item) => {
			if (item.id === id) {
				item['requiredDate'] = value;
			}
			if (!item.requiredDate) {
				item['requiredDate'] = value;
			}
			return item;
		});
		setSelectedDesigns([...updatedDesigns]);
		let error = errors.filter((err) => err.type !== 'DATE');
		setErrors(error);
	};

	const isValidAtleastOneRow = (colors) => {
		let isValid = false;
		colors.forEach((item) => {
			if (item.quantity && item.size) {
				isValid = true;
			}
		});
		return isValid;
	};

	const processSampleQtyList = (body) => {
		let isValid = true;
		body.forEach((item) => {
			if (item.sampleQuantityList.length > 0) {
				item.sampleQuantityList.forEach((color) => {
					if (color?.colorDTO?.name && !color.size) {
						setErrors((old) => [
							...old,
							{
								errorDesignId: item.productId,
								errorKey: color.key,
								type: 'SIZE'
							}
						]);
						isValid = false;
					}
					if (color?.colorDTO?.name && !color.quantity) {
						setErrors((old) => [
							...old,
							{
								errorDesignId: item.productId,
								errorKey: color.key,
								type: 'QUANTITY'
							}
						]);
						isValid = false;
					}
					if (color.size && !color.quantity) {
						setErrors((old) => [
							...old,
							{
								errorDesignId: item.productId,
								errorKey: color.key,
								type: 'QUANTITY'
							}
						]);
						isValid = false;
					}
					if (color.quantity && !color.size) {
						setErrors((old) => [
							...old,
							{
								errorDesignId: item.productId,
								errorKey: color.key,
								type: 'SIZE'
							}
						]);
						isValid = false;
					}
				});
			}
		});
		return isValid;
	};

	const isValidForm = (body, type) => {
		let isValid = true;
		if (type === 'SAMPLE_DETAILS') {
			isValid = processSampleQtyList(body);
			for (let item of body) {
				if (!isValidAtleastOneRow(item.sampleQuantityList)) {
					setErrors((old) => [
						...old,
						{
							errorDesignId: item.productId,
							errorKey: item.sampleQuantityList[0].key,
							type: 'SIZE'
						}
					]);
					setErrors((old) => [
						...old,
						{
							errorDesignId: item.productId,
							errorKey: item.sampleQuantityList[0].key,
							type: 'QUANTITY'
						}
					]);
					isValid = false;
				}
			}
		} else if (type === 'OPERATIONAL_UNIT') {
			body.forEach((item) => {
				if (!item.operationalUnitId) {
					setErrors((old) => [
						...old,
						{
							errorDesignId: item.isSetMember ? item.setId : item.productId,
							type: 'OPERATIONAL_UNIT'
						}
					]);
					isValid = false;
				}
			});
		} else {
			body.forEach((item) => {
				if (!item.requiredDate) {
					setErrors((old) => [
						...old,
						{ errorDesignId: item.isSetMember ? item.setId : item.productId, type: 'DATE' }
					]);
					isValid = false;
				}
			});
		}

		return isValid;
	};

	const getFomattedData = () => {
		const formattedData = [];
		const selectedData = selectedDesigns;
		selectedData.forEach((item) => {
			if (item.isSet) {
				item.setItemsList.forEach((memberOfSet) => {
					const obj = {
						isSetMember: true,
						setId: item?.id,
						requiredDate: item?.requiredDate,
						operationalUnitId: item.operationalUnitId,
						remarks: item.remarks,
						productId: memberOfSet.id,
						sampleQuantityList: memberOfSet.colorResponseList.map((color) => {
							return {
								colorDTO: {
									name: color.code,
									colorType: 'SOLID',
									representedBy: 'PANTONE_OR_HEX_CODE',
									compositeColorList: [],
									pantoneColorId: color.pantoneColorId,
									swatchDocumentId: null
								},
								key: color.key,
								quantity: color.quantity || null,
								size: color.size || null
							};
						})
					};
					formattedData.push(obj);
				});
			}
		});
		selectedData.forEach((item) => {
			if (!item.isSet) {
				const obj = {
					isSetMember: false,
					productId: item.id,
					requiredDate: item.requiredDate,
					operationalUnitId: item.operationalUnitId,
					remarks: item.remarks,
					sampleQuantityList: item.colorResponseList.map((color) => {
						return {
							colorDTO: {
								name: color.code,
								colorType: 'SOLID',
								representedBy: 'PANTONE_OR_HEX_CODE',
								compositeColorList: [],
								pantoneColorId: color.pantoneColorId,
								swatchDocumentId: null
							},
							key: color.key,
							quantity: color.quantity || null,
							size: color.size || null
						};
					})
				};
				formattedData.push(obj);
			}
		});
		return formattedData;
	};

	const isValidColorPopup = (body) => {
		let isValid = processSampleQtyList(body);
		for (let item of body) {
			if (item.productId === designId && !isValidAtleastOneRow(item.sampleQuantityList)) {
				setErrors((old) => [
					...old,
					{
						errorDesignId: item.productId,
						errorKey: item.sampleQuantityList[0].key,
						type: 'SIZE'
					},
					{
						errorDesignId: item.productId,
						errorKey: item.sampleQuantityList[0].key,
						type: 'QUANTITY'
					}
				]);
				isValid = false;
			}
		}
		return isValid;
	};

	const getFilteredSelectedColors = () => {
		const copySelectedColors = !isColorAddedOnce
			? selectedColors.filter((color) => {
					if (color.code && color.hexCode && color.pantoneColorId && color.size && color.quantity) {
						return color;
					}
				})
			: [];
		return copySelectedColors;
	};

	const autoAddColorOnSelectOne = () => {
		const cloneSelectedDesigns = selectedDesigns.map((item) => {
			if (item.colorResponseList) {
				item.colorResponseList.forEach((color, index) => {
					if (
						(!color.size && !color.quantity) ||
						!color.code ||
						!color.hexCode ||
						!color.pantoneColorId
					) {
						getFilteredSelectedColors().forEach((selectedColor, idx) => {
							if (index === idx) {
								color.code = selectedColor.code;
								color.hexCode = selectedColor.hexCode;
								color.pantoneColorId = selectedColor.pantoneColorId;
								color.size = selectedColor.size;
								color.quantity = selectedColor.quantity;
								color.colorType = 'SOLID';
							}
						});
					}
					return color;
				});
			}
			if (item.isSet) {
				item.setItemsList.forEach((memberOfSet) => {
					memberOfSet.colorResponseList.forEach((color, index) => {
						if (
							(!color.size && !color.quantity) ||
							!color.code ||
							!color.hexCode ||
							!color.pantoneColorId
						) {
							getFilteredSelectedColors().forEach((selectedColor, idx) => {
								if (index === idx) {
									color.code = selectedColor.code;
									color.hexCode = selectedColor.hexCode;
									color.pantoneColorId = selectedColor.pantoneColorId;
									color.size = selectedColor.size;
									color.quantity = selectedColor.quantity;
									color.colorType = 'SOLID';
								}
							});
						}
						return color;
					});
					return memberOfSet;
				});
			}
			return item;
		});
		setSelectedDesigns(cloneSelectedDesigns);
	};
	const onSubmitColorSizeQuantity = (e) => {
		e.stopPropagation();
		autoAddColorOnSelectOne();
		let formattedInputs = getFomattedData();
		const isValid = isValidColorPopup(formattedInputs, 'SAMPLE_DETAILS');
		if (!isValid) return;
		setDesignId(null);
	};

	const formatColorResponseList = (colorResponseList) =>
		colorResponseList.map((color) => ({
			colorDTO: {
				name: color?.code || color?.name,
				colorType: color.colorType,
				representedBy: 'PANTONE_OR_HEX_CODE',
				compositeColorList: [],
				pantoneColorId: color.pantoneColorId,
				swatchDocumentId: null
			},
			quantity: color.quantity || null,
			size: color.size || null
		}));

	const formatSampleRequestBody = () => {
		return selectedDesigns
			.map((design) => ({
				operationalUnitId: design.operationalUnitId,
				productId: design.id,
				requiredDate: design.requiredDate,
				isSet: design.isSet,
				remarks: design.remarks,
				sampleQuantityList: design.isSet
					? undefined
					: formatColorResponseList(design.colorResponseList),
				setMembersSampleRequestList: design.isSet
					? design.setItemsList.map((item) => ({
							remarks: item.remarks || design.remarks,
							operationalUnitId: item.operationalUnitId || design.operationalUnitId,
							productId: item.id,
							requiredDate: item.requiredDate || design.requiredDate,
							isSet: false,
							sampleQuantityList: formatColorResponseList(item.colorResponseList)
						}))
					: undefined
			}))
			.filter((design) => design.isSet || design.sampleQuantityList);
	};

	const onSubmitSampleRequest = async () => {
		setErrors([]);
		let body = getFomattedData();
		const isValid = isValidForm(body, 'DATE');
		const isValidSampleDetails = isValidForm(body, 'SAMPLE_DETAILS');
		const isValidOperationalUnit = isValidForm(body, 'OPERATIONAL_UNIT');
		let isValidEoDate = true;
		if (!eoDate && !checkUserType('FASHION_DESIGNER')) {
			setIsEoDateError(true);
			isValidEoDate = false;
		}
		if (!selectedAssignee?.value) {
			setAssigneeError(true);
			isValidEoDate = false;
		}
		if (!isValid || !isValidSampleDetails || !isValidOperationalUnit || !isValidEoDate) return;
		const sampleRequestBodyData = formatSampleRequestBody();

		setErrors([]);
		dispatch(openLoader());
		await ApiClient.POST(
			'sampleDetailsAction',
			{
				developmentSample: source === 'DEVELOPMENT',
				addSampleRequestList: [...sampleRequestBodyData],
				expectedOrderDate: eoDate,
				assigneeId: selectedAssignee?.value
			},
			`collection/${id}`
		)
			.then(({ data }) => {
				dispatch(closeLoader());
				toastSuccess(data.message);
				dispatch(clearSampleRequest());
				navigate(`/sample/view/${data.id}`);
				onClose();
			})
			.catch((error) => {
				dispatch(closeLoader());
				toastError(error.response.data.message);
			});
	};

	const isValidInput = (body) => {
		setErrors([]);
		let isValid = true;
		body.forEach((item) => {
			if (!item.requiredDate) {
				setErrors((old) => [...old, { errorDesignId: item.productId, type: 'DATE' }]);
				isValid = false;
			}
		});

		return isValid;
	};

	const onCostingRequest = async () => {
		let body = selectedDesigns?.map((item) => {
			return {
				productId: item.id,
				requiredDate: item.requiredDate
			};
		});
		const isValid = isValidInput(body);
		let noAssignee = false;
		if (!selectedAssignee?.value) {
			noAssignee = true;
		}
		setAssigneeError(noAssignee);

		if (!isValid || noAssignee) return;
		setErrors([]);
		dispatch(openLoader());
		await ApiClient.POST('addBulkInitialCosting', body)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data.success) {
					toastSuccess(data.message);
					dispatch(clearSampleRequest());
					onClose();
				}
			})
			.catch((error) => {
				dispatch(closeLoader());
				toastError(error.response.data.message);
			});
	};

	const onPhotoshootRequest = async () => {
		let body = selectedDesigns?.map((item) => {
			return {
				productId: item.id,
				requiredDate: item.requiredDate
			};
		});
		const isValid = isValidInput(body);
		if (!isValid) return;
		setErrors([]);
		dispatch(openLoader());
		await ApiClient.POST('photographyRequest', body)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data.success) {
					toastSuccess(data.message);
					dispatch(clearSampleRequest());
					onClose();
				}
			})
			.catch((error) => {
				dispatch(closeLoader());
				toastError(error.response.data.message);
			});
	};

	const onSubmit = async () => {
		if (requestType === 'SAMPLE') return onSubmitSampleRequest();
		if (requestType === 'COSTING') return onCostingRequest();
		if (requestType === 'PHOTOSHOOT') return onPhotoshootRequest();
	};

	const onGetDateError = (item) => {
		return errors.some((err) => err?.errorDesignId === item.id && err?.type === 'DATE');
	};

	const onGetCountryError = (item) => {
		return errors.some((err) => err?.errorDesignId === item.id && err?.type === 'OPERATIONAL_UNIT');
	};

	const onGetSampleError = (item) => {
		return errors.some(
			(err) => err?.errorDesignId === item.id && (err?.type === 'DATE' || err?.type === 'QUANTITY')
		);
	};

	const onCancelPopUp = () => {
		dispatch(clearSampleRequest());
		onClose('CANCEL');
	};

	const handleDropDown = (obj, selectedId) => {
		let updatedDesigns = selectedDesigns;
		updatedDesigns.forEach((item) => {
			if (item.id === selectedId) {
				item['operationalUnitId'] = obj.id;
				item['operationalUnitName'] = obj.value;
			}
			if (!item.operationalUnitId) {
				item['operationalUnitId'] = obj.id;
				item['operationalUnitName'] = obj.value;
			}
			return item;
		});
		setSelectedDesigns([...updatedDesigns]);
		let error = errors.filter((err) => err.type !== 'OPERATIONAL_UNIT');
		setErrors(error);
	};

	const handleRemarks = (e) => {
		let updatedDesigns = [...selectedDesigns];
		updatedDesigns.forEach((item) => {
			if (item.id === selectedRowId) {
				item['remarks'] = e.target.value;
			}
			return item;
		});
		setSelectedDesigns([...updatedDesigns]);
	};
	const renderSetDetailsColumn = (memberOfSet = []) => {
		const setItMembersList = memberOfSet.slice(1);
		return setItMembersList.map((item) => (
			<tr key={item?.id}>
				<td
					onClick={() => onDesignClick(item?.id)}
					className={`${
						onGetSampleError(item) ? 'common-border-error position-relative' : 'position-relative'
					}`}
				>
					<SampleColorPopUp
						colorList={item.colorResponseList}
						selectedDesignId={designId}
						item={item}
						onCancel={(e) => {
							e.stopPropagation();
							setDesignId(null);
						}}
						onChangeColorItem={onChangeColorItem}
						onClickAddNewItem={onClickAddNew}
						onClickColorSubmit={(e) => {
							onSubmitColorSizeQuantity(e);
						}}
						errors={errors}
					/>
				</td>
			</tr>
		));
	};

	useEffect(() => {
		if (selectedAssignee?.country?.id) {
			let tmpCountryList = allCountryList?.filter(
				(item) => item.country.id === selectedAssignee.country.id
			);
			setCountryList(tmpCountryList);
			let updatedDesigns = selectedDesigns;
			updatedDesigns.forEach((item) => {
				item['operationalUnitId'] = undefined;
				item['operationalUnitName'] = '';
				return item;
			});
			setSelectedDesigns([...updatedDesigns]);
		}
	}, [selectedAssignee]);

	return (
		<Modal
			show={true}
			onHide={onCancelPopUp}
			backdrop="static"
			className="width-1200-modal sample-details-modal"
		>
			<div className="common-popup add-sample-details-popup shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">
							{requestType === 'SAMPLE'
								? 'Sample Request'
								: requestType === 'COSTING'
									? 'Costing'
									: 'Photoshoot'}
						</h3>
					</div>

					<div className="close-btn" onClick={onCancelPopUp}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<Modal.Body>
					<div className="common-popup-body pb-0 scroll-y-label">
						<div className="sample-details-table scroll-x-label">
							{requestType !== 'PHOTOSHOOT' && (
								<div className="row">
									<div className="col-md-4">
										<div className="form-group no-shadow-react-select">
											<label htmlFor="po-number">
												{requestType === 'COSTING' ? 'Costing Manager' : 'Assignee'}*
											</label>
											<Select
												onChange={(selected) => {
													setSelectedAssignee({
														label: selected.label,
														value: selected.value,
														country: selected.country
													});
												}}
												value={selectedAssignee}
												options={assigneeList}
												className={assigneeError ? 'common-border-error' : ''}
											/>
										</div>
									</div>
									<div className="col-md-4">
										<EODate
											eoDate={eoDate}
											setEoDate={(val) => {
												setIsEoDateError(false);
												setEoDate(val);
											}}
											isEoDateError={isEoDateError}
										/>
									</div>
								</div>
							)}
							<table className="table with-border mt-2">
								<thead>
									<tr>
										<th className="design-details-column">
											<span className="ml-2">
												{selectedDesignIds.length > 1 ? 'Designs' : 'Design'}
												{`(${selectedDesignIds.length})`}
											</span>
										</th>
										{requestType === 'SAMPLE' && (
											<th className="sample-details-column">Sample details</th>
										)}
										<th className="date-column">Required date</th>
										{requestType === 'SAMPLE' && (
											<th className="sample-details-column">
												Country In-house/factory
											</th>
										)}
										{requestType === 'SAMPLE' && (
											<th className="sample-details-column">Remarks</th>
										)}
									</tr>
								</thead>
								<tbody>
									{selectedDesigns.map((item) => {
										let uniqueId = item.id;
										return (
											<>
												<tr key={item.id}>
													<td className="" rowSpan={item?.setMemberCount}>
														{item?.isSet ? (
															<div className="d-flex align-items-center">
																<div
																	className="set-image-layout"
																	style={{ width: ' 56px' }}
																>
																	<img
																		src={item?.designDocuments[0]?.docUrl}
																		alt="image"
																		className="cell-img pr-2"
																	/>
																	<img
																		src={item?.designDocuments[1]?.docUrl}
																		alt="image"
																		className="cell-img pr-2"
																	/>
																</div>
																<div className="ml-12">
																	{item?.isSet && setTag()}

																	<p className="regular-12 gray_dark_01 py-1">
																		{item?.name}
																	</p>
																	<ul className="common-list-component mb-2">
																		<li>
																			{
																				item?.setItemsList[0]
																					?.productGroup
																			}
																		</li>
																		<li>
																			{item?.setItemsList[0]?.category}
																		</li>
																		<li>
																			{item?.setItemsList[1]?.category}
																		</li>
																	</ul>
																</div>
															</div>
														) : (
															<div className="d-flex align-items-center">
																<img
																	src={item?.designDocuments[0]?.docUrl}
																	alt="image"
																	className="cell-img"
																/>
																<div className="ml-2">
																	{item?.isPack && packTag()}
																	<p className="regular-12 gray_dark_01 py-1">
																		{item.referenceNumber}{' '}
																	</p>
																	<ul className="common-list-component mb-2">
																		<li>{item?.productGroup}</li>
																		<li>{item?.subCategory}</li>
																	</ul>
																</div>
															</div>
														)}
													</td>
													{requestType === 'SAMPLE' &&
														(item?.isSet ? (
															<td
																onClick={() =>
																	onDesignClick(item?.setItemsList[0]?.id)
																}
																className={`${
																	onGetSampleError(item?.setItemsList[0])
																		? 'common-border-error position-relative'
																		: 'position-relative'
																}`}
															>
																<SampleColorPopUp
																	colorList={
																		item?.setItemsList[0]
																			?.colorResponseList
																	}
																	selectedDesignId={designId}
																	item={item?.setItemsList[0]}
																	onCancel={(e) => {
																		e.stopPropagation();
																		setDesignId(null);
																	}}
																	onChangeColorItem={onChangeColorItem}
																	onClickAddNewItem={onClickAddNew}
																	onClickColorSubmit={(e) => {
																		onSubmitColorSizeQuantity(e);
																	}}
																	errors={errors}
																/>
															</td>
														) : (
															<td
																onClick={() => onDesignClick(item?.id)}
																className={`${
																	onGetSampleError(item) &&
																	'common-border-error'
																}`}
															>
																<SampleColorPopUp
																	colorList={item.colorResponseList}
																	selectedDesignId={designId}
																	item={item}
																	onCancel={(e) => {
																		e.stopPropagation();
																		setDesignId(null);
																	}}
																	onChangeColorItem={onChangeColorItem}
																	onClickAddNewItem={onClickAddNew}
																	onClickColorSubmit={(e) => {
																		onSubmitColorSizeQuantity(e);
																	}}
																	errors={errors}
																/>
															</td>
														))}
													<td
														className="date-column"
														rowSpan={item?.setMemberCount}
													>
														<div
															className={`${
																onGetDateError(item) && 'common-border-error'
															}`}
														>
															<input
																id={uniqueId}
																type="date"
																name="required-date"
																min={getTodaysDate()}
																value={item?.requiredDate}
																onChange={(e) =>
																	onChangeDate(e.target.value, uniqueId)
																}
															/>
														</div>
													</td>
													{requestType === 'SAMPLE' && (
														<td rowSpan={item?.setMemberCount}>
															<div
																className={`single-filter ${
																	onGetCountryError(item) &&
																	'common-border-error'
																}`}
															>
																<CustomDropdown
																	type="addItem"
																	title={'Country'}
																	onItemSearch={() => false}
																	onItemClick={(obj) =>
																		handleDropDown(obj, item.id)
																	}
																	items={countryList}
																	selectedItem={item?.operationalUnitName}
																	isDisabled={!selectedAssignee?.value}
																/>
															</div>
														</td>
													)}
													{requestType === 'SAMPLE' && (
														<td
															onClick={() => {
																if (selectedRowId === null) {
																	setSelectedRowId(item.id);
																}
															}}
															rowSpan={item?.setMemberCount}
														>
															{selectedRowId === item.id && (
																<input
																	autoFocus={true}
																	type="text"
																	autoComplete="off"
																	name="remarks"
																	value={item.remarks ? item.remarks : ''}
																	onChange={handleRemarks}
																	onBlur={() => setSelectedRowId(null)}
																/>
															)}
															{selectedRowId !== item.id && item.remarks}
														</td>
													)}
												</tr>
												{item?.isSet && renderSetDetailsColumn(item?.setItemsList)}
											</>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCancelPopUp}>
							<span className="gray_dark_02">Cancel</span>
						</button>
						<button
							className="button size32 ml-2"
							onClick={() => {
								onSubmit();
							}}
							disabled={isLoading}
						>
							Submit
						</button>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default SampleAdd;
